import { render, staticRenderFns } from "./QSummitSidebarHeader.vue?vue&type=template&id=d23f9f2c&scoped=true&"
var script = {}
import style0 from "./QSummitSidebarHeader.vue?vue&type=style&index=0&id=d23f9f2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23f9f2c",
  null
  
)

export default component.exports